import { useNavigate } from "react-router-dom";
import { Calendar, MapPin, ArrowRight } from "lucide-react";
import { WorldCupLogo } from "@/components/world-cup/WorldCupLogo";

/**
 * Compact promotional card shown in place of the generic "No fixtures found"
 * empty state during the FIFA World Cup 2026 window. Clicking navigates to the
 * dedicated /world-cup hub.
 */
export function WorldCupPromoCard() {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate("/world-cup")}
      className="group relative w-full max-w-2xl mx-auto block text-left overflow-hidden rounded-2xl border border-primary/30 bg-gradient-to-br from-primary/15 via-background to-background p-6 md:p-8 transition-colors hover:border-primary/60"
    >
      <div className="pointer-events-none absolute -right-4 -top-4 opacity-25">
        <WorldCupLogo size={180} decorative className="w-[160px] h-[160px] md:w-[180px] md:h-[180px]" />
      </div>

      <div className="relative space-y-3">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-primary font-semibold">
          <WorldCupLogo size={18} /> FIFA World Cup 2026
        </div>

        <h3
          className="text-2xl md:text-3xl font-black leading-tight"
          style={{ fontFamily: "Surgena, sans-serif", color: "rgba(255,200,50,0.85)" }}
        >
          The World Plays in 3 Homes
        </h3>

        <p className="text-sm text-muted-foreground max-w-md">
          48 nations · 16 stadiums · 104 matches across Canada, Mexico and the United States.
        </p>

        <div className="flex flex-wrap gap-2 pt-1">
          <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-card border border-border text-xs">
            <Calendar size={12} className="text-primary" /> 11 Jun – 19 Jul 2026
          </span>
          <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-card border border-border text-xs">
            <MapPin size={12} className="text-primary" /> CA · MX · US
          </span>
        </div>

        <div className="flex items-center gap-1.5 pt-2 text-sm font-semibold text-primary group-hover:gap-2.5 transition-all">
          Open World Cup Hub <ArrowRight size={14} />
        </div>
      </div>
    </button>
  );
}
